if (!window.customElements.get('popup-dialog')) {
  class PopupDialog extends HTMLElement {
    constructor() {
      super();
      this.focusableElements = [];
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.scrollLock = null;
      this.scrollPosition = 0;
      this.close = this.close.bind(this);
      this.open = this.open.bind(this);
    }
  
    reInit() {
      this.dialog = this.querySelector('.popup__wrap') || (this.id && document.getElementById(this.id + '-wrap'));
      if (!this.dialog) return false;

      this.trigger = this.trigger || this.querySelector('button.popup__trigger');
      this.dialogId = this.dialogId || this.id;
      this.closeButton = this.closeButton || this.dialog.querySelector('.popup__close');
      this.overlay = this.overlay || this.dialog.querySelector('.popup__overlay');
      this.modal = this.modal || this.dialog.querySelector('.popup');

      if (this.trigger) {
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
      }

      this.dialog.setAttribute('role', 'dialog');
      this.dialog.setAttribute('aria-modal', 'true');
      this.dialog.setAttribute('aria-hidden', 'true');
      this.closeButton?.setAttribute('aria-label', 'Close dialog');

      if (this.dialog.parentElement !== document.body) {
        document.body.appendChild(this.dialog);
        if (this.trigger) {
          this.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
          });
        }
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        if (document.querySelector(`[data-a11y-dialog-hide="${this.dialogId}"]`)) {
          document.querySelectorAll(`[data-a11y-dialog-hide="${this.dialogId}"]`).forEach(btn => btn.addEventListener('click', () => this.close()));
        }
        this.scrollLock = this.scrollLock || document.querySelector('scroll-lock');
      }
      return true;
    }

    connectedCallback() {
      this.reInit();
    }

    open() {
      if (!this.dialog && !this.reInit()) return;

      this.dialog.classList.add('active');
      this.overlay.classList.add('active');
      setTimeout(() => {
        this.modal.classList.add('active');
      }, 150);
      this.dialog.setAttribute('aria-hidden', 'false');
      this.focusableElements = Array.from(
        this.dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      );
      if (this.closeButton) {
        this.closeButton.focus();
      }
  
      if(this.scrollLock){
        this.scrollLock.lock()
      }
  
      document.addEventListener('keydown', this.handleKeyDown);

      this.dispatchEvent(new CustomEvent('show'));

    }
  
    close() {

      if(!this.dialog) return;

      this.dialog.classList.remove('active');
      this.overlay.classList.remove('active');
      this.modal.classList.remove('active');
      this.dialog.setAttribute('aria-hidden', 'true');
      if(this.trigger){
        this.trigger.focus();
      }
  
      document.removeEventListener('keydown', this.handleKeyDown);
  
      setTimeout(() => {
        document.querySelector("html").style.scrollBehavior = "auto";
        // window.scrollTo(0, this.scrollPosition);
      }, 10);    
    
      if(this.scrollLock){
        this.scrollLock.unlock()
      }
      
      // if(this.id === "collection-filters-modal"){
      //   const mainElement = document.getElementById("main");
      //   const elementPosition = mainElement.getBoundingClientRect().top + window.pageYOffset;
  
      //   window.scrollTo({
      //     top: elementPosition,
      //     behavior: 'smooth'
      //   });
      // }
      
      this.dispatchEvent(new CustomEvent('hide'));
  
    }
  
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
      } else if (event.key === 'Tab') {
        const first = this.focusableElements[0];
        const last = this.focusableElements[this.focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }
  
  customElements.define('popup-dialog', PopupDialog);
}
